module.exports = __webpack_public_path__ + "static/media/PromoVC.ac414ff2.png";